'use client';

import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import type { ComponentProps, Dispatch, SetStateAction } from 'react';
import DialogHeader from '../dialog/DialogHeader';
import styles from './modal.module.css';

type Props = Omit<ComponentProps<typeof Dialog>, 'onHide'> & {
	onHide?: () => undefined | (() => void);
	setVisible: Dispatch<SetStateAction<boolean>>;
	withCloseButton?: boolean;
	isCustomContent?: boolean;
	onCloseRouteElsewhere?: boolean;
	route?: string;
};

const FullScreenModal = ({
	onHide,
	header,
	visible,
	setVisible,
	children,
	withCloseButton = true,
	isCustomContent = false,
	onCloseRouteElsewhere = false,
	route = '',
}: Props) => {
	const navigate = useNavigate();

	const checkNav = () => {
		if (onCloseRouteElsewhere) {
			return navigate(route);
		}
		if (!visible) return;
		setVisible(false);
	};

	return (
		<Dialog
			visible={visible}
			closable={withCloseButton}
			onHide={checkNav || onHide}
			header={
				typeof header === 'string' ? (
					<DialogHeader title={header} />
				) : (
					header
				)
			}
			draggable={false}
			pt={{
				header: () => ({
					className: header ? styles.modalHeader : 'invisible',
				}),
				closeButton: () => ({
					className: styles.closeButton,
				}),
				content: () => ({
					className: isCustomContent
						? styles.customContent
						: styles.modalContent,
				}),
				mask: () => ({
					className: styles.modalMask,
				}),
			}}
			className={isCustomContent ? styles.customModal : styles.modal}
		>
			{children}
		</Dialog>
	);
};

export default FullScreenModal;
